import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [showCookiePopup, setShowCookiePopup] = useState(false);

  useEffect(() => {
    // Check if user already accepted cookies
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    const cookieLifeInDays = 2;
    
    if (!cookiesAccepted) {
      setShowCookiePopup(true);
    } else {
      // Check if cookie consent has expired
      const acceptedDate = new Date(parseInt(cookiesAccepted));
      const currentDate = new Date();
      const daysDifference = Math.floor((currentDate - acceptedDate) / (1000 * 60 * 60 * 24));
      
      if (daysDifference >= cookieLifeInDays) {
        setShowCookiePopup(true);
      }
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", Date.now().toString());
    setShowCookiePopup(false);
  };

  return (
    <>
      <footer className="footer_5_main_footer">
        <div className="footer_5_footer_first">
          <section>
            <div className="footer_5_footer_articles"></div>
          </section>
        </div>
        <div className="footer_5_footer_second">
          <section>
            <div className="copyright">
              <p>© aufantasy. All rights reserved.</p>
            </div>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/play">How to play</Link>
              </li>
              <li>
                <Link to="/system">Balls system</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookie">Cookie Policy</Link>
              </li>
              <li>
                <Link to="/contacts">Contacts</Link>
              </li>
            </ul>
          </section>
        </div>
      </footer>

      {showCookiePopup && (
        <div
          className="footer_5_cookie_popup"
          id="footer_5_cookie_popup"
        >
          <div className="footer_5_cookie_content">
            <p>
              We use cookies to improve your experience. By using our website, you
              agree to our <Link to="/cookie">cookie policy</Link>.
            </p>
            <button 
              className="footer_5_btn_accept" 
              id="footer_5_accept_cookies"
              onClick={acceptCookies}
            >
              Accept
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;